import * as React from 'react';
import { SignalSource } from '../data/SignalSource';
import LiveComponent from '../components/LiveComponent';
import { getSignalAt, getStoreState } from '../state/Store';

interface Props {
  signal: SignalSource;
  invert?: boolean;
}

export class SignalVerticalBar extends LiveComponent<Props> {
  bar = React.createRef<HTMLDivElement>();
  width: number;
  tick() {
    let { signal, invert } = this.props;
    if (this.bar.current) {
      const { motionSource } = getStoreState().flyer;
      let level = getSignalAt(
        signal,
        motionSource.getCurrentTime() / motionSource.getDuration()
      );
      if (invert) {
        level = 1 - level;
      }
      this.bar.current.style.transform = 'translateY(-' + level * 100 + '%)';
    }
  }

  render() {
    return (
      <div className="signal-vertical-bar">
        <div ref={this.bar} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/controller/SignalVerticalBar.tsx